import React, { useEffect } from 'react'
import { Button, Checkbox, Divider, FormControlLabel, FormGroup, Grid, Radio, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import CustomHeader from '../../components/CustomHeader'
import Section from '../../components/CustomSection'
import CustomRadioButtonGroup from '../../components/CustomRadioButtonGroup';
import { getLogo, isVumaReachPackage } from '../../utils/commons'
import { dataUtil, usage_type } from '../../services/wsclients/dataUtil'
import CustomSection from '../../components/CustomSection'
import { paths } from '../../config/router.config'
import { useHistory } from 'react-router-dom'
import CustomCircularProgress from '../../components/CustomCircularProgress'
import theme from '../../theme.css'
import CustomButton from '../../components/CustomButton'

const useStyles = makeStyles((theme) => ({
    package: {
        width: '100%',
        height: 300,
        objectFit: 'contain'
    },
    content: {
        padding: theme.spacing(2),
        paddingTop: theme.spacing(10),
    },
    support_device: {
        width: '60%',
        height: 'auto',
        objectFit: 'contain'
    },
    list_device: {
        justifyContent: 'center',
        marginTop: theme.spacing(2),
        textAlign: 'center',
    },
    device: {
        cursor: 'pointer',
    },
    device_info: {
        textAlign: 'center',
    },
    device_image: {
        width: '100%',
        height: 100,
        objectFit: 'contain',
    },
    device_select: {
        textAlign: 'center',
    },
    item_image: {
        display: 'block',
        margin: 'auto',
        width: '100%',
    },
    right_info: {
        marginLeft: theme.spacing(5),
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
            padding: theme.spacing(2, 4),
        },
    }
}));

export default function PackageInfoView(props) {
    const { packageInfo, currency, physicalGoods, physicalGoodSelected, paymentMethodSelected, setPaymentMethodSelected, loadingPrice, packageConfirmation } = props;
    const { t } = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    let discountedInstallation = document._portalConfig.discountedInstallation ? document._portalConfig.discountedInstallation : 0;
    let activationFees = document._portalConfig.activationFees ? document._portalConfig.activationFees : 0;

    let routerFees = document._portalConfig.routerFees ? document._portalConfig.routerFees : 0;
    let deliveryFees = document._portalConfig.deliveryFees ? document._portalConfig.deliveryFees : 0;
    let promo = document._portalConfig.promo ? document._portalConfig.promo : 0;
    let price = 0;
    // console.log("AAAA PackageInfoView price: ", price)
    if (packageInfo) {
        if (props.selected == '1') {
            price = packageInfo.price_o ? packageInfo.price_o : packageInfo.price;
        } else if (props.selected == '2') {
            price = packageInfo.price_r ? packageInfo.price_r : packageInfo.price;
        }
    }
    let totalAmount = price ? Number(price) : 0;
    totalAmount += discountedInstallation + activationFees + routerFees + deliveryFees - promo;

    let discountedInstallationText = document._portalConfig.discountedInstallationText ? document._portalConfig.discountedInstallationText : null;
    let activationFeesText = document._portalConfig.activationFeesText ? document._portalConfig.activationFeesText : null;

    let discountedInstallationAndActivationFee = document._portalConfig.discountedInstallationAndActivationFee ? document._portalConfig.discountedInstallationAndActivationFee : 0;
    let discountedInstallationAndActivationFeeText = document._portalConfig.discountedInstallationAndActivationFeeText ? document._portalConfig.discountedInstallationAndActivationFeeText : 0;
    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, []);
    console.log("AAAA packageInfo: ", packageInfo)
    const customFields = packageConfirmation?.product?.custom_fields || [];
    const downloadSpeed = customFields.find((item) => item.key === "download_speed")?.value;
    const uploadSpeed = customFields.find((item) => item.key === "upload_speed")?.value;
    return (
        <Grid container alignItems="center" justifyContent="center">
            <Grid xs={12} sm={5} md={5} lg={4} item >
                <img className={classes.item_image} src={packageConfirmation.image_url || getLogo()} alt="package" />
                {/* {packageConfirmation.code === "BASE-PREPAID-10-10" && (
                    <Typography variant="body2" style={{ color: theme.palette.common.red, marginTop: 8 }}>
                        {t('oct10_not_available_in_all_areas')}
                    </Typography>
                )} */}
            </Grid>

            <Grid xs={12} sm={6} md={6} lg={4} item className={classes.right_info}>
                <Typography variant="subtitle1"><li>{t('fly_smart_monthly')}</li></Typography>
                <Typography variant="subtitle1"><li>Download: {downloadSpeed || '-'} Mbps</li></Typography>
                <Typography variant="subtitle1"><li>Upload: {uploadSpeed || '-'} Mbps</li>
                </Typography>
                {!isVumaReachPackage(packageConfirmation?.product_type) && <Typography variant="subtitle1" className={classes.price}><li>{currency}{packageConfirmation.price} {t('per_month')} </li></Typography>}
                <Typography marginY={3} variant="subtitle1">{t('cancel_anytime')}</Typography>
                <Grid item xs={12} my={2} mt={4} container justifyContent={'center'}>
                    <CustomButton onClick={props.onCheckOut} variant={'contained'}>{t('btn_confirm_continue')}</CustomButton>
                </Grid>
            </Grid>
            {packageInfo && packageInfo.devices && packageInfo.devices.length > 0 && <Grid item xs={12} container justifyContent={"center"}>
                <Grid xs={12} sm={12} md={12} lg={8} xl={6} item>
                    <Section title={t('devices_title')}>
                        <Typography>{t('please_select_device')}</Typography>
                        <Grid item xs={12} container className={classes.list_device}>
                            {packageInfo.devices.map((item, index) => {
                                return (
                                    <Grid item xs={12} md={4} key={index}>
                                        <DeviceItem
                                            classes={classes}
                                            t={t}
                                            item={item}
                                            currency={currency}
                                            deviceSelected={props.deviceSelected}
                                            onChangeDevice={props.onChangeDevice}
                                        />
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Section>
                </Grid>
            </Grid>}
        </Grid>
    );
}

function ProductImage(props) {
    if (props.image && props.image.url) {
        return <img className={props.classes.package} src={props.image.url} />
    } return <img className={props.classes.package} src={getLogo()} />;
}

function BillPayment(props) {
    const { t, options, selected, onChangeOption } = props;

    return (
        <CustomSection
            title={t('choose_bill_payment')}
        >
            <CustomRadioButtonGroup
                items={options}
                selected={selected ? selected : null}
                onChange={onChangeOption}
            />
        </CustomSection>
    );
}

function StoreCard(props) {
    const { t, options, selected, onChangeOption } = props;

    return (
        <CustomSection
            title={t('store_card_option')}
        >
            <CustomRadioButtonGroup
                items={options}
                selected={selected ? selected : null}
                onChange={onChangeOption}
            />
        </CustomSection>
    );
}

function DeviceItem(props) {
    const { item, t, classes, onChangeDevice, deviceSelected, currency } = props;
    let image = item.creatives ? dataUtil.getImageByUsageTypePortal(item.creatives, "AVATAR") : null;
    let price = item.pricing && item.pricing.length > 0 ? item.pricing[0] : null;
    return (
        <Grid item xs={12} className={classes.device} onClick={() => onChangeDevice(item)}>
            <Grid item xs={12}>
                {image && image.url ? <img className={props.classes.device_image} src={image.url} /> : <img className={props.classes.device_image} src={getLogo()} />}
            </Grid>
            <Grid item xs={12} className={classes.device_info}>
                <Typography>{item.name ? item.name : ''}</Typography>
                <Typography>{currency}{price && price.price ? Number(price.price.toFixed(2)) : "0.00"}</Typography>
            </Grid>
            <Grid item xs={12} className={classes.device_select}>
                <Radio
                    checked={deviceSelected && deviceSelected.id === item.id}
                    onChange={() => onChangeDevice(item)}
                    value={item.id}
                    name="radio-buttons"
                    inputProps={{ 'aria-label': item.id }}
                />
            </Grid>
        </Grid>
    )
}